import { FASTElement as i, html as m } from "@microsoft/fast-element";
import { listboxValuesStyles as r } from "./listbox-values.styles.js";
import { Icon as c } from "../../icon/index.js";
const s = class s extends i {
  setValues(l) {
    this.innerHTML = "", l.forEach((n) => {
      const e = document.createElement("span");
      e.classList.add("selected-value"), e.textContent = n.textContent;
      const t = new c("x-mark");
      t.size = "1rem", t.addEventListener("click", (a) => {
        a.stopPropagation(), n.selected = !1;
      }), e.appendChild(t), this.appendChild(e);
    });
  }
};
s.definition = {
  name: "listbox-values",
  template: () => m` <slot></slot>`,
  styles: () => r
};
let o = s;
export {
  o as ListboxValues
};
